import React from 'react';
import { useLaunchCountdown } from '../hooks/useLaunchCountdown';
function Unit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-[68px] flex-col items-center sm:w-[86px]" data-id="element-11" data-mp="1y33fi0uwdcaw">
      <span className="font-display text-5xl leading-none tabular-nums text-lime sm:text-6xl" data-id="element-12" data-mp="1tajval1pfix4">{value}</span>
      <span className="mt-2 text-[10px] font-extrabold uppercase tracking-[0.16em] text-snow-dim sm:text-xs" data-id="element-13" data-mp="1obqmv719yi3t">
        {label}
      </span>
    </div>;
}

/** Isolated so the per-second tick re-renders only these digits. */
export function CountdownTimer() {
  const {
    hours,
    minutes,
    seconds
  } = useLaunchCountdown();
  return <div className="flex min-h-[104px] items-center justify-center gap-1 rounded-2xl border border-gold/40 bg-ink px-4 py-4 sm:min-h-[120px] sm:gap-2 sm:px-7" role="timer" aria-live="off" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-14" data-mp="1aekabu759fn1">
      <Unit value={hours} label="HS" data-id="element-15" data-mp="2zpuiehnigeaz" />
      <span className="-mt-4 font-display text-3xl text-gold" aria-hidden="true" data-id="element-16" data-mp="1c0f8rk2rwqxp">
        :
      </span>
      <Unit value={minutes} label="MIN" data-id="element-17" data-mp="1h01jnmv4pv3c" />
      <span className="-mt-4 font-display text-3xl text-gold" aria-hidden="true" data-id="element-18" data-mp="1h12v3sg24jll">
        :
      </span>
      <Unit value={seconds} label="SEG" data-id="element-19" data-mp="124lp7gqmzx6f" />
    </div>;
}